// MOCK DATA — dark mode redesign with Emergent showcase as cases

export const BRAND = {
  name: 'Thesis',
  tagline: 'Estúdio de Marketing Digital',
  city: 'Belo Horizonte',
  region: 'MG — Brasil',
  phoneRaw: '5531935002294',
  phoneFormatted: '(31) 93500-2294',
  email: 'contato@thesis.studio',
  instagram: '@thesisparavida',
  instagramUrl: 'https://www.instagram.com/thesisparavida/',
  founded: '2025',
  coords: '19.92S • 43.94W',
};

export const WHATSAPP_LINK = (msg = 'Olá! Vim do site da Thesis e quero saber mais sobre os planos.') =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { label: 'Serviços', href: '/#servicos' },
  { label: 'Cases', href: '/#cases' },
  { label: 'Processo', href: '/#processo' },
  { label: 'Preços', href: '/#precos' },
  { label: 'Blog', href: '/blog' },
  { label: 'FAQ', href: '/#faq' },
];

export const SERVICES = [
  {
    id: 'social', number: '01', title: 'Social Media',
    short: 'Sua presença digital, planejada e executada.',
    items: ['Planejamento de conteúdo mensal', 'Criação de posts profissionais', 'Calendário editorial organizado', 'Roteiros para vídeos e reels', 'Stories estratégicos'],
  },
  {
    id: 'conteudo', number: '02', title: 'Criação de Conteúdo',
    short: 'Conteúdo que para o feed e converte.',
    items: ['Posts para Instagram / Facebook', 'Carrosséis que geram engajamento', 'Reels que viralizam', 'Capas de stories profissionais', 'Textos que vendem'],
  },
  {
    id: 'apresentacoes', number: '03', title: 'Apresentações',
    short: 'Slides que vendem antes de você falar.',
    items: ['Slides para reuniões', 'Propostas comerciais bonitas', 'Apresentação institucional', 'Deck de resultados mensais'],
  },
  {
    id: 'sites', number: '04', title: 'Sites',
    short: 'Sites profissionais a partir de R$ 600.',
    items: ['Site one page (página única)', 'Site institucional 5 páginas', 'Landing page de produto', 'Manutenção mensal opcional'],
  },
];

// Cases — imagens das demos públicas da Emergent. Cada nome de cliente foi escolhido
// para combinar com o setor visível na pr\u00f3pria interface mostrada.
export const CASES = [
  {
    id: 1,
    company: 'Cine Plateia',
    sector: 'Entretenimento • Cinema',
    plan: 'Landing de lan\u00e7amento + Social Media',
    metric: '+1.2M views no trailer',
    period: 'Pr\u00e9-estreia',
    summary: 'Landing page de lan\u00e7amento com identidade cinematogr\u00e1fica e calend\u00e1rio editorial sincronizado.',
    laptop: 'https://assets.emergent.sh/assets/showcase/Laptop1.webp',
    mobile: 'https://assets.emergent.sh/assets/showcase/Mob1.webp',
    tag: 'Entretenimento',
  },
  {
    id: 2,
    company: 'Inkria Estampas',
    sector: 'Moda • E-commerce streetwear',
    plan: 'Plano Movimento + Site',
    metric: '+412% de pedidos online',
    period: '4 meses',
    summary: 'E-commerce one page de camisetas autorais + conte\u00fado de coleta\u00e7\u00f5es e drops semanais.',
    laptop: 'https://assets.emergent.sh/assets/showcase/Laptop2.webp',
    mobile: 'https://assets.emergent.sh/assets/showcase/Mob2.webp',
    tag: 'E-commerce',
  },
  {
    id: 3,
    company: 'NauTrack',
    sector: 'SaaS • Tech',
    plan: 'Landing + Plano Autoridade',
    metric: 'MRR triplicou em 6 meses',
    period: '6 meses',
    summary: 'Reposicionamento de produto SaaS com landing focada em demo + funil de conte\u00fado t\u00e9cnico.',
    laptop: 'https://assets.emergent.sh/assets/showcase/Laptop3.webp',
    mobile: 'https://assets.emergent.sh/assets/showcase/Mob3.webp',
    tag: 'SaaS',
  },
  {
    id: 4,
    company: 'ContaSmart',
    sector: 'Fintech • App pessoal',
    plan: 'Site institucional + Plano Movimento',
    metric: '+34 leads qualificados / sem',
    period: 'Ongoing',
    summary: 'Site institucional + campanhas de captura para app de finan\u00e7as pessoais.',
    laptop: 'https://assets.emergent.sh/assets/showcase/Laptop4.webp',
    mobile: 'https://assets.emergent.sh/assets/showcase/Mob4.webp',
    tag: 'Fintech',
  },
];

export const PROCESS = [
  { n: '01', title: 'Briefing rápido', desc: 'Conversa de 15 min no WhatsApp pra entender objetivo, público e voz da marca.' },
  { n: '02', title: 'Estratégia & calendário', desc: 'Você recebe a estratégia e o calendário editorial pra aprovar antes de qualquer post.' },
  { n: '03', title: 'Produção de conteúdo', desc: 'Eu crio cada peça com atenção visual e copy pensada pra converter.' },
  { n: '04', title: '1 rodada de ajustes', desc: 'Refinamos juntos. Sem custo extra, sem burocracia.' },
  { n: '05', title: 'Entrega + relatório', desc: 'Entrega quinzenal e relatório simples mostrando o que funcionou.' },
];

export const PLANS = [
  { id: 'essencial', name: 'Essencial', price: 300, posts: 15, network: 1, stories: '—', reels: '—', report: 'Básico', highlight: false, description: 'Pra quem está começando e precisa de presença consistente.' },
  { id: 'presenca', name: 'Presença', price: 450, posts: 20, network: 1, stories: 4, reels: '—', report: 'Sim', highlight: false, description: 'Mais volume e stories estratégicos pra acelerar o crescimento.' },
  { id: 'movimento', name: 'Movimento', price: 650, posts: 20, network: 2, stories: 8, reels: 2, report: 'Detalhado', highlight: true, description: 'O combo completo: 2 redes, reels e relatório detalhado.' },
  { id: 'autoridade', name: 'Autoridade', price: 900, posts: 24, network: 2, stories: 12, reels: 4, report: 'Completo + reuniões', highlight: false, description: 'Pra marcas que querem virar referência. Inclui reuniões mensais.' },
];

export const SITES_PLANS = [
  { id: 'onepage', name: 'One Page', price: 600, suffix: 'pagamento único', desc: 'Página única que vende. 5 dias úteis.' },
  { id: 'inst', name: 'Institucional', price: 1200, suffix: 'pagamento único', desc: 'Até 5 páginas. Estrutura SEO básica.' },
  { id: 'landing', name: 'Landing Page', price: 500, suffix: 'pagamento único', desc: 'Foco em conversão. Pra campanhas e produtos.' },
  { id: 'manut', name: 'Manutenção', price: 150, suffix: '/mês', desc: 'Atualizações, backup e ajustes mensais.' },
];

export const FAQ = [
  { q: 'Preciso enviar material?', a: 'Sim. Fotos, logo (se tiver) e um briefing básico. Eu organizo e direciono tudo no início.' },
  { q: 'E se eu não gostar do conteúdo?', a: '1 rodada de ajustes grátis por lote de entrega. Refinamos juntos até ficar do jeito certo.' },
  { q: 'Vocês postam nas minhas redes?', a: 'Não. Entrego tudo pronto, organizado e nomeado pra você (ou seu time) postar com 1 clique.' },
  { q: 'Quanto tempo demora o site?', a: '5 dias úteis pra um one page. Institucional em até 10 dias úteis.' },
  { q: 'Posso contratar só 1 mês?', a: 'Sim. Sem fidelidade. Você renova quando quiser.' },
  { q: 'Atende fora de Belo Horizonte?', a: 'Sim. Trabalho com clientes do Brasil inteiro 100% remoto via WhatsApp e e-mail.' },
];

export const TESTIMONIALS = [
  { name: 'Sofia A.', role: 'Inkria Estampas', text: 'Valeu cada centavo. Os pedidos online dispararam depois que entramos no plano Movimento.' },
  { name: 'Pedro M.', role: 'Cine Plateia', text: 'Conteúdo afiado, copy certeira e entrega no prazo. Time profissional de verdade.' },
  { name: 'Ana B.', role: 'NauTrack', text: 'A landing nova fechou demos mais rápido do que a gente esperava. Mudou o jogo aqui.' },
  { name: 'Bruno R.', role: 'ContaSmart', text: 'Site lindo, rápido e bem feito. Os leads chegam mais qualificados — dá pra sentir a diferença.' },
];

export const MARQUEE = ['Social Media', 'Sites Profissionais', 'Identidade Visual', 'Reels & Carrosséis', 'Apresentações', 'Landing Pages', 'Estratégia de Conteúdo', 'Copy que Converte'];

export const STATS = [
  { v: '+50', l: 'Marcas atendidas' },
  { v: '4.9', l: 'Avaliação média' },
  { v: '<1h', l: 'Tempo de resposta' },
  { v: '0%', l: 'Fidelidade obrigatória' },
];
